import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

export const fetchPermissions = createAsyncThunk(
  'permission/fetchPermissions',
  async (user, thunkAPI) => {
    try {
      const token = localStorage.getItem('jwt_access_token');

      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      };

      const rolesRes = await axios.get(
        `${process.env.REACT_APP_BASE_API_URL}/auth/Permission/GetAll`,
        config
      );

      const existUserRoleNames = user.roles;

      const roleIds = rolesRes.data
        .filter((role) => existUserRoleNames.includes(role.name))
        .map((role) => role.name);

      const requestBody = {
        UserId: user.id,
        roles: roleIds,
      };

      const accessRes = await axios.post(
        `${process.env.REACT_APP_BASE_API_URL}/auth/Permission/UserAccess`,
        requestBody,
        config
      );

      const permissions = accessRes.data?.roles?.filter((item) => item.permissions.length > 0);
      return permissions;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data?.message || 'Permission error');
    }
  }
);
